import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import DatosPersonales from './DatosPersonales';
import DatosMedicos from './DatosMedicos';
import DesarrolloMotrizLenguaje from './DesarrolloMotrizLenguaje';
import DesarrolloSocialAfectivo from './DesarrolloSocialAfectivo';
import Antecedentes from './Antecedentes';
import CartaCompromiso from './CartaCompromiso';
import SeleccionPlan from './SeleccionPlan';
import { registrarMatricula } from '../../services/matriculaService';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const FormularioMatricula = () => {
    const navigate = useNavigate();
    const LOCAL_STORAGE_KEY = 'REGISTRO_MATRICULA_PROGRESO';
    const [currentStep, setCurrentStep] = useState(1);
    const [planSeleccionado, setPlanSeleccionado] = useState(null);
    const [matriculaRegistrada, setMatriculaRegistrada] = useState(false);
    const [mostrarBotones, setMostrarBotones] = useState(false);
    const [formData, setFormData] = useState({
        nombre: '',
        apellidos: '',
        cedula: '',
        noCedula: false,
        lugarNacimiento: '',
        fechaNacimiento: '',
        direccion: '',
        numeroHermanosVarones: 0,
        numeroHermanosMujeres: 0,
        hermanos: [],
        viveCon: '',
        pasaTiempoCon: '',
        observacionesEntorno: '',
        seccion: '',
        idPadre: null,
        institucion_anterior: '',
        expectativas_institucion: '',
        tipoParto: '',
        semanasGestacion: '0',
        causaCesarea: '',
        peso: '',
        estatura: '',
        complicacionesParto: false,
        complicacionesPartoDetalle: '',
        complicacionesEmbarazo: false,
        complicacionesEmbarazoDetalle: '',
        cuidadosExtras: false,
        cuidadosExtrasDetalle: '',
        enfermedades: '',
        problemasVision: false,
        problemasVisionDetalle: '',
        problemasAudicion: false,
        problemasAudicionDetalle: '',
        ingresosHospitalarios: '',
        alergias: '',
        accidentes: '',
        operacionesQuirurgicas: false,
        operacionesQuirurgicasDetalle: '',
        enfermedadesCronicas: '',
        antecedentesFamiliares: '',
        controlNeurologico: false,
        controlNeurologicoDetalle: '',
        discapacidad: false,
        discapacidadDetalle: '',
        // Desarrollo motriz y lenguaje
        gateo: false,
        edadInicioGateo: '',
        edadInicioCaminar: '',
        tipoLactancia: '',
        edadFinLactancia: '',
        manoDominante: '',
        controlEsfinteresDiurno: false,
        controlEsfinteresNocturno: false,
        edadControlEsfinteres: '',
        idiomaCasa: '',
        edadBalbuceo: '',
        edadPalabrasSueltas: '',
        edadHablar: '',
        terapiaLenguaje: false,
        terapiaLenguajeDetalle: '',
        habitosSuenoConQuien: '',
        habitosSuenoEdad: '',
        dificultadesSueno: '',
        observacionesControlEsfinteres: '',
        // Desarrollo social y afectivo
        juega_con_otros: '',
        tiempo_celular_tv: '',
        relacion_ninos: '',
        relacion_adultos: '',
        afectuoso: '',
        independiente: '',
        sigue_instrucciones: '',
        organiza_objetos: '',
        pasatiempos: '',
        dificultad_relaciones: false,
        dificultad_relaciones_detalle: '',
        programas_favoritos: '',
        personalidad: '',
        actividades_agradables_dibujar: '',
        actividades_agradables_cantar: '',
        actividades_agradables_escuchar_musica: '',
        actividades_agradables_mirar_tv: '',
        actividades_agradables_ir_al_cine: '',
        actividades_agradables_escuchar_cuentos: '',
        actividades_agradables_realizar_deportes: '',
        actividades_agradables_video_infantiles: '',
        // Plan seleccionado
        plan_seleccionado: null,
        id_plan: null,
        
        // Carta de compromiso
        carta_compromiso_aceptada: false,
        id_carta_compromiso: null
    });

    const [isSubmitting, setIsSubmitting] = useState(false);
    const [errors, setErrors] = useState({});

    useEffect(() => {
        // Load saved progress from localStorage
        const savedProgress = localStorage.getItem(LOCAL_STORAGE_KEY);
        let initialFormData = { ...formData }; // Start with default formData

        if (savedProgress) {
            try {
                const parsedProgress = JSON.parse(savedProgress);
                if (parsedProgress.formData) {
                    initialFormData = { ...initialFormData, ...parsedProgress.formData };
                }
                if (parsedProgress.currentStep) {
                    setCurrentStep(parsedProgress.currentStep);
                }
            } catch (error) {
                console.error("Error parsing saved progress:", error);
                // Optionally clear corrupted data
                // localStorage.removeItem(LOCAL_STORAGE_KEY);
            }
        }

        // Set idPadre from logged-in user, potentially overriding saved one
        const user = JSON.parse(localStorage.getItem('user'));
        if (user && user.id) {
            initialFormData.idPadre = user.id;
            
            // Verificar que el usuario tenga el rol correcto
            if (user.rol !== 'Padre') {
                console.error('Usuario no tiene rol de Padre:', user.rol);
                // Redirigir al dashboard apropiado según el rol
                if (user.rol === 'Administrador') {
                    navigate('/admin/dashboard');
                } else if (user.rol === 'Profesor') {
                    navigate('/profesor/dashboard');
                } else {
                    navigate('/login');
                }
                return;
            }
        } else {
            console.error('No se encontró usuario en localStorage');
            navigate('/login');
            return;
        }
        
        setFormData(initialFormData);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // Run only once on mount

    // Save progress to localStorage with debounce
    useEffect(() => {
        const handler = setTimeout(() => {
            // Do not save if idPadre is not set yet (implies initial load might not be complete)
            if (formData.idPadre !== null && formData.idPadre !== undefined) { 
                localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify({ formData, currentStep }));
            }
        }, 500); // Debounce time: 500ms

        return () => {
            clearTimeout(handler);
        };
    }, [formData, currentStep]);

    const validateStep = () => {
        const newErrors = {};

        if (currentStep === 1) {
            if (!formData.nombre?.trim()) newErrors.nombre = 'El nombre es requerido';
            if (!formData.apellidos?.trim()) newErrors.apellidos = 'Los apellidos son requeridos';
            if (!formData.lugarNacimiento?.trim()) newErrors.lugarNacimiento = 'El lugar de nacimiento es requerido';
            if (!formData.fechaNacimiento) newErrors.fechaNacimiento = 'La fecha de nacimiento es requerida';
            if (!formData.direccion?.trim()) newErrors.direccion = 'La dirección es requerida';
            
            if (formData.fechaNacimiento) {
                const birthDate = new Date(formData.fechaNacimiento);
                const today = new Date();
                today.setHours(0, 0, 0, 0); // Resetear la hora a medianoche
                const maxDate = new Date();
                maxDate.setHours(0, 0, 0, 0); // Resetear la hora a medianoche
                
                if (birthDate > maxDate) {
                    newErrors.fechaNacimiento = 'La fecha de nacimiento no puede ser mayor a la fecha actual';
                }

                // Calcular edad
                let age = today.getFullYear() - birthDate.getFullYear();
                const monthDiff = today.getMonth() - birthDate.getMonth();
                if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
                    age--;
                }

                if (age >= 3 && !formData.noCedula) {
                    if (!formData.cedula?.trim()) {
                        newErrors.cedula = 'La cédula es requerida para niños mayores de 3 años';
                    } else if (!validarCedula(formData.cedula)) {
                        newErrors.cedula = 'La cédula ingresada no es válida';
                    }
                }
            }
        }

        if (currentStep === 2) {
            if (!formData.peso) newErrors.peso = 'El peso es requerido';
            if (!formData.estatura) newErrors.estatura = 'La estatura es requerida';
            if (!formData.alergias?.trim()) newErrors.alergias = 'El campo alergias es requerido';
            if (!formData.enfermedades?.trim()) newErrors.enfermedades = 'Las enfermedades padecidas son requeridas';
        }

        if (currentStep === 6) {
            if (!formData.id_plan) {
                newErrors.plan = 'Debe seleccionar un plan para continuar';
            }
        }

        if (currentStep === 7) {
            if (!formData.carta_compromiso_aceptada) {
                newErrors.carta_compromiso = 'Debe aceptar la carta de compromiso para continuar';
            }
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const validarCedula = (cedula) => {
        // Algoritmo de validación de cédula de Ecuador
        if (cedula.length !== 10) return false;

        let total = 0;
        const coeficientes = [2, 1, 2, 1, 2, 1, 2, 1, 2];

        for (let i = 0; i < coeficientes.length; i++) {
            let valor = parseInt(cedula.charAt(i)) * coeficientes[i];
            total += valor >= 10 ? valor - 9 : valor;
        }

        const digitoVerificador = parseInt(cedula.charAt(9));
        const ultimoDigito = total % 10 === 0 ? 0 : 10 - (total % 10);

        return ultimoDigito === digitoVerificador;
    };

    const nextStep = () => {
        if (validateStep()) {
            setCurrentStep(currentStep + 1);
        } else {
            // Mostrar mensaje de error específico para el paso 6 (selección de plan)
            if (currentStep === 6 && !formData.id_plan) {
                toast.error('Debe seleccionar un plan para continuar', {
                    position: 'top-right',
                    autoClose: 3000,
                    style: { 
                        marginTop: '10px',
                        fontFamily: '"Exo 2", sans-serif',
                        fontWeight: 500
                    }
                });
            }
        }
    };

    const prevStep = () => setCurrentStep(currentStep - 1);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    const handlePlanSeleccionado = (plan) => {
        setPlanSeleccionado(plan);
        setFormData(prev => ({
            ...prev,
            plan_seleccionado: plan,
            id_plan: plan.id_plan
        }));
    };

    const handleAceptarCarta = (idCarta) => {
        setFormData((prevState) => ({
            ...prevState,
            carta_compromiso_aceptada: true,
            id_carta_compromiso: idCarta
        }));
        setErrors(prevErrors => {
            const newErrors = { ...prevErrors };
            delete newErrors.carta_compromiso;
            return newErrors;
        });
    };

    const handleRechazarCarta = () => {
        setFormData((prevState) => ({
            ...prevState,
            carta_compromiso_aceptada: false,
            id_carta_compromiso: null
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateStep()) {
            return;
        }
        
        // Validar que se haya seleccionado un plan
        if (!formData.id_plan) {
            toast.error('Debe seleccionar un plan para registrar la matrícula', {
                position: 'top-right',
                autoClose: 3000,
                style: { 
                    marginTop: '10px',
                    fontFamily: '"Exo 2", sans-serif',
                    fontWeight: 500
                }
            });
            return;
        }
        
        // Validar que se haya aceptado la carta de compromiso
        if (!formData.carta_compromiso_aceptada) {
            toast.error('Debe aceptar la carta de compromiso para registrar la matrícula', {
                position: 'top-right',
                autoClose: 3000,
                style: { 
                    marginTop: '10px',
                    fontFamily: '"Exo 2", sans-serif',
                    fontWeight: 500
                }
            });
            return;
        }

        setIsSubmitting(true);
        const datosMatricula = {
            nombre: formData.nombre,
            apellidos: formData.apellidos,
            cedula: formData.cedula,
            fecha_nacimiento: formData.fechaNacimiento,
            lugar_nacimiento: formData.lugarNacimiento,
            direccion: formData.direccion,
            numero_hermanos_varones: formData.numeroHermanosVarones,
            numero_hermanos_mujeres: formData.numeroHermanosMujeres,
            vive_con: formData.viveCon,
            pasa_tiempo_con: formData.pasaTiempoCon,
            observaciones_entorno: formData.observacionesEntorno,
            seccion: formData.seccion,
            id_padre: formData.idPadre,
            institucion_anterior: formData.institucion_anterior,
            expectativas: formData.expectativas_institucion,
            hermanos: formData.hermanos.filter((hermano) => hermano.nombre && hermano.edad && hermano.lugar_ocupa),
            datos_medicos: {
                tipo_parto: formData.tipoParto,
                semanas_gestacion: formData.semanasGestacion,
                causa_cesarea: formData.causaCesarea || null,
                peso: formData.peso,
                estatura: formData.estatura,
                complicaciones_parto: formData.complicacionesParto,
                complicaciones_parto_detalle: formData.complicacionesPartoDetalle,
                complicaciones_embarazo: formData.complicacionesEmbarazo,
                complicaciones_embarazo_detalle: formData.complicacionesEmbarazoDetalle,
                cuidados_extras: formData.cuidadosExtras,
                cuidados_extras_detalle: formData.cuidadosExtrasDetalle,
                enfermedades: formData.enfermedades,
                problemas_vision: formData.problemasVision,
                problemas_vision_detalle: formData.problemasVisionDetalle,
                problemas_audicion: formData.problemasAudicion,
                problemas_audicion_detalle: formData.problemasAudicionDetalle,
                ingresos_hospitalarios: formData.ingresosHospitalarios,
                alergias: formData.alergias,
                accidentes: formData.accidentes,
                operaciones_quirurgicas: formData.operacionesQuirurgicas,
                operaciones_quirurgicas_detalle: formData.operacionesQuirurgicasDetalle,
                enfermedades_cronicas: formData.enfermedadesCronicas,
                antecedentes_familiares: formData.antecedentesFamiliares,
                control_neurologico: formData.controlNeurologico,
                control_neurologico_detalle: formData.controlNeurologicoDetalle,
                discapacidad: formData.discapacidad,
                discapacidad_detalle: formData.discapacidadDetalle,
            },
            desarrollo_motriz_lenguaje: {
                gateo: formData.gateo,
                edad_inicio_gateo: formData.edadInicioGateo,
                edad_inicio_caminar: formData.edadInicioCaminar,
                tipo_lactancia: formData.tipoLactancia,
                edad_fin_lactancia: formData.edadFinLactancia,
                mano_dominante: formData.manoDominante,
                control_esfinteres_diurno: formData.controlEsfinteresDiurno,
                control_esfinteres_nocturno: formData.controlEsfinteresNocturno,
                edad_control_esfinteres: formData.edadControlEsfinteres,
                idioma_casa: formData.idiomaCasa,
                edad_balbuceo: formData.edadBalbuceo,
                edad_palabras_sueltas: formData.edadPalabrasSueltas,
                edad_hablar: formData.edadHablar,
                terapia_lenguaje: formData.terapiaLenguaje,
                terapia_lenguaje_detalle: formData.terapiaLenguajeDetalle,
                detalles_esfinteres: formData.observacionesControlEsfinteres,
                dificultades_sueno: formData.dificultadesSueno,
                edad_inicio_dormir_solo: formData.habitosSuenoEdad,
                companero_sueno: formData.habitosSuenoConQuien
            },
            desarrollo_socio_afectivo: {
                juega_con_otros: formData.juega_con_otros,
                tiempo_celular_tv: formData.tiempo_celular_tv,
                relacion_ninos: formData.relacion_ninos,
                relacion_adultos: formData.relacion_adultos,
                afectuoso: formData.afectuoso,
                independiente: formData.independiente,
                sigue_instrucciones: formData.sigue_instrucciones,
                organiza_objetos: formData.organiza_objetos,
                pasatiempos: formData.pasatiempos,
                dificultad_relaciones: formData.dificultad_relaciones,
                dificultad_relaciones_detalle: formData.dificultad_relaciones_detalle,
                actividades_agradables_dibujar: formData.actividades_agradables_dibujar,
                actividades_agradables_cantar: formData.actividades_agradables_cantar,
                actividades_agradables_escuchar_musica: formData.actividades_agradables_escuchar_musica,
                actividades_agradables_mirar_tv: formData.actividades_agradables_mirar_tv,
                actividades_agradables_ir_al_cine: formData.actividades_agradables_ir_al_cine,
                actividades_agradables_escuchar_cuentos: formData.actividades_agradables_escuchar_cuentos,
                actividades_agradables_realizar_deportes: formData.actividades_agradables_realizar_deportes,
                actividades_agradables_video_infantiles: formData.actividades_agradables_video_infantiles,
                programas_favoritos: formData.programas_favoritos,
                personalidad: formData.personalidad
            },
            carta_compromiso: {
                aceptada: formData.carta_compromiso_aceptada,
                id_carta: formData.id_carta_compromiso
            },
            id_plan: formData.id_plan
        };

        try {
            const response = await registrarMatricula(datosMatricula);
            console.log('Matrícula registrada:', response);
            localStorage.removeItem(LOCAL_STORAGE_KEY);
            setMatriculaRegistrada(true);
            toast.success('¡Matrícula registrada exitosamente!', {
                position: 'top-right',
                autoClose: 5000,
                style: { 
                    marginTop: '10px',
                    fontFamily: '"Exo 2", sans-serif',
                    fontWeight: 500
                }
            });
            
            // Mostrar botones después de un breve delay
            setTimeout(() => {
                setMostrarBotones(true);
            }, 2000);
        } catch (error) {
            console.error('Error al registrar la matrícula:', error);
            if (error.message.includes('cédula ya está registrada')) {
                setErrors(prevErrors => ({
                    ...prevErrors,
                    cedula: 'La cédula ya está registrada para otro niño. Por favor verifique el número ingresado.'
                }));
                setCurrentStep(1); // Regresa al primer paso donde está el campo de cédula
                toast.error('La cédula ya está registrada para otro niño', {
                    position: 'top-right',
                    autoClose: 3000,
                    style: { 
                        marginTop: '10px',
                        fontFamily: '"Exo 2", sans-serif',
                        fontWeight: 500
                    }
                });
            } else {
                toast.error('Error al registrar la matrícula: ' + error.message, {
                    position: 'top-right',
                    autoClose: 3000,
                    style: { 
                        marginTop: '10px',
                        fontFamily: '"Exo 2", sans-serif',
                        fontWeight: 500
                    }
                });
            }
        }
        setIsSubmitting(false);
    };

    return (
        <div className="max-w-8xl mx-auto p-6 bg-white shadow-md rounded-md">
            <ToastContainer />
            <h2 className="text-2xl font-semibold text-center mb-6">Formulario de Matriculación</h2>

            <form onSubmit={handleSubmit}>
                {currentStep === 1 && (
                    <DatosPersonales 
                        formData={formData} 
                        setFormData={setFormData}
                        handleInputChange={handleInputChange}
                        errors={errors}
                    />
                )}
                {currentStep === 2 && (
                    <DatosMedicos 
                        formData={formData} 
                        setFormData={setFormData}
                        handleInputChange={handleInputChange} 
                        errors={errors}
                    />
                )}
                {currentStep === 3 && (
                    <DesarrolloMotrizLenguaje
                        formData={formData}
                        setFormData={setFormData}
                        handleInputChange={handleInputChange}
                    />
                )}
                {currentStep === 4 && (
                    <DesarrolloSocialAfectivo
                        formData={formData}
                        setFormData={setFormData}
                        handleInputChange={handleInputChange}
                    />
                )}
                {currentStep === 5 && (
                    <Antecedentes
                        formData={formData}
                        handleInputChange={handleInputChange}
                    />
                )}
                {currentStep === 6 && (
                    <SeleccionPlan
                        onPlanSeleccionado={handlePlanSeleccionado}
                        planSeleccionado={planSeleccionado}
                    />
                )}
                {currentStep === 7 && (
                     <CartaCompromiso
                         onAceptar={handleAceptarCarta}
                         onRechazar={handleRechazarCarta}
                         cartaAceptada={formData.carta_compromiso_aceptada}
                         planSeleccionado={planSeleccionado}
                     />
                 )}

                <div className="flex mt-4">
                    <div className="flex-1">
                        {currentStep > 1 && (
                            <button
                                type="button"
                                className="bg-gray-500 text-white p-2 rounded-md"
                                onClick={prevStep}
                            >
                                Anterior
                            </button>
                        )}
                    </div>
                    <div>
                        {currentStep < 7 && (
                            <button
                                type="button"
                                className="bg-blue-500 text-white p-2 rounded-md"
                                onClick={nextStep}
                            >
                                Siguiente
                            </button>
                        )}
                        {currentStep === 7 && !matriculaRegistrada && (
                            <button
                                type="submit"
                                className="bg-green-500 text-white p-2 rounded-md"
                                disabled={isSubmitting || !formData.carta_compromiso_aceptada || !formData.id_plan}
                            >
                                {isSubmitting ? 'Registrando...' : 'Registrar Matrícula'}
                            </button>
                        )}
                        {currentStep === 7 && matriculaRegistrada && mostrarBotones && (
                            <button
                                type="button"
                                className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-md transition-colors"
                                onClick={() => navigate('/padre')}
                            >
                                Regresar al Inicio
                            </button>
                        )}
                    </div>
                </div>
            </form>
        </div>
    );
};

export default FormularioMatricula;
